// const hostname = window.location.hostname.split('.').slice(-2).join('.');

// production Url or Live ===>>>
//  const siteUrl = 'https://api.foxearch.com/';
// const siteUrl = 'https://foxearch.com/'; 
  const siteUrl = 'https://uat.foxearch.com/'; 

// Development Url ===>>>      
// const siteUrl = "http://ec2-3-111-47-154.ap-south-1.compute.amazonaws.com:8000/"

// New added ===>>> 
// const siteUrl = "http://ec2-13-233-93-76.ap-south-1.compute.amazonaws.com:5000/"
// const siteUrl = "http://ec2-3-111-181-217.ap-south-1.compute.amazonaws.com:8000/"

// export async function UploadFile(url, body, token) {
//   // console.log("====token==>")   
         
//   const init = {                    
//     method: 'POST',                    
//     headers: {                        
//       token: token, 
//       // 'Content-Type': 'multipart/form-data',
//       // 'content-Type': 'multipart/form-data; boundary=--------------------------386650167365198011592528'
//     },   
//     body: body,           
//   };                  
//   try {    
//     const res = await fetch(siteUrl + url, init);
//     const data = await res.json();
//     var apiData = {  
//       status: res.status,      
//       data: data,  
 
//     };
//     return apiData;
//   } catch (err) {
//     return 'error';
//   }
// }
 // development Url 
 // const siteUrl="http://ec2-52-66-239-255.ap-south-1.compute.amazonaws.com:8000/"

// development Url 
// development Url 
// const siteUrl="http://ec2-52-66-244-15.ap-south-1.compute.amazonaws.com:8000/";
// development 
//  const siteUrl="http://ec2-65-1-147-73.ap-south-1.compute.amazonaws.com:8000/"
// development 

    //  const siteUrl="http://ec2-43-204-140-171.ap-south-1.compute.amazonaws.com:8000/"
   //  const siteUrl="http://ec2-3-111-47-154.ap-south-1.compute.amazonaws.com:8000/"


export async function Api(url, apiMethod, body, tokenn) {
  const init = apiMethod === 'GET'? {
          method: 'GET',
          headers: {
            //  'Authorization': token
            'Content-Type': 'application/json',
            token: tokenn,
            "dateNow":new Date().getTime(),
          },
        }
      : {
          method: apiMethod,
          headers: {
            token: tokenn,
            'Content-Type': 'application/json',
            "dateNow":new Date().getTime(),
          },
          body: JSON.stringify(body),
        };

  try {
    const res = await fetch(siteUrl + url, init);
    // const data = await res.json();
    
    const apiData = {
      status: res.status,
      data: await res.json()
    };
    return apiData;
  } catch (err) {
    return 'error';
  }
}


export async function UploadFile(url, bodyy, tokenn) {
  // console.log("====token==>")

  const init = {
    method: 'POST',
    headers: {
      token: tokenn,
      "dateNow":new Date().getTime(),
      // 'Content-Type': 'multipart/form-data',
      // 'content-Type': 'multipart/form-data; boundary=--------------------------386650167365198011592528'
    },
    body:bodyy
  };
  try {
    const res = await fetch(siteUrl + url, init);
    
     const dataa = await res.json();
    // console.log("res",dataa);
    const apiData = {
      status: res.status,
      data: dataa
    };
    return apiData;
  } catch (err) {
    return 'error';
  }
}
